import { render, staticRenderFns } from "./FundPensions.vue?vue&type=template&id=3570e9ba"
import script from "./FundPensions.vue?vue&type=script&lang=js"
export * from "./FundPensions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports